<template>
    <div class="display-box" >
        <div class="module-layout">
            <el-select v-model="col" size="mini" style="width:60px;margin:0 10px" @change="changeLayout">
                <el-option :value="1">1</el-option>
                <el-option :value="2">2</el-option>
                <el-option :value="3">3</el-option>
                <el-option :value="4">4</el-option>
            </el-select>
            <div>列</div>
            <div style="marginLeft:20px">排版</div>
        </div>
        <draggable
                :group="{ name: 'module', put: true }"
                @add="addModuleItem"
                @update="sortModuleItem"
                :value="moduleItems"
                animation="300"
                class="module-draggable"
                :style="col == 1 ?   'justify-content: center' : ''"
                :ghostClass="`card-items-ghost-${col}`"
        >
            <div
                    class="module-items"
                    :style="col == 1 ? 'width: 33%' : `width: ${handleWidth(Number(col))}`"
                    v-for="(item, index) in moduleItems"
                    :key="item.code"
            >
                <!-- <div class="module-item">{{item.title}}
                  <i class="el-icon-error" @click="removeModules(item, index)"></i>
                </div> -->
                <div class="module-item" >
                    <!--规章制度、业务流程和常用下载-->
                    <div class="titleClass" v-if="item.code == 'TINFO_RULES' || item.code == 'TINFO_BUSINESS' || item.code == 'TINFO_DOWNLOAD'">
                        <div class="flex-box al-c mb10" style="color: #024A84;">
                            <span class="ml10 font-14">{{item.title}}</span>
                        </div>
                        <div>更多<i class="el-icon-arrow-right"></i></div>
                    </div>
                    <div v-if="item.code == 'TINFO_RULES'">
                        <template>
                            <p class="po-r mt10 mb10 font-12 ellipsis cu-p flex-box msg-item"  v-for="(e, i) in rulesList" :key="i" >
                                <span class="flex-1 mr10 ellipsis">{{e.name}}</span>
                                <span class="grey">{{e.createTime}}</span>
                            </p>
                        </template>
                        <div v-if="rulesList.length == '0'" class="po-r mt10 mb10 font-12 ellipsis cu-p flex-box msg-item">暂无数据</div>
                        <i class="el-icon-error" @click="removeModules(item, index)"></i>
                    </div>
                    <div v-if="item.code == 'TINFO_BUSINESS'">
                        <template>
                            <p class="po-r mt10 mb10 font-12 ellipsis cu-p flex-box msg-item"  v-for="(e, i) in businessList" :key="i" >
                                <span class="flex-1 mr10 ellipsis">{{e.name}}</span>
                                <span class="grey">{{e.createTime}}</span>
                            </p>
                        </template>
                        <div v-if="businessList.length == '0'" class="po-r mt10 mb10 font-12 ellipsis cu-p flex-box msg-item">暂无数据</div>
                        <i class="el-icon-error" @click="removeModules(item, index)"></i>
                    </div>
                    <div v-if="item.code == 'TINFO_DOWNLOAD'">
                        <template>
                            <p class="po-r mt10 mb10 font-12 ellipsis cu-p flex-box msg-item"  v-for="(e, i) in downloadList" :key="i" >
                                <span class="flex-1 mr10 ellipsis">{{e.name}}</span>
                                <span class="grey">{{e.createTime}}</span>
                            </p>
                        </template>
                        <div v-if="downloadList.length == '0'" class="po-r mt10 mb10 font-12 ellipsis cu-p flex-box msg-item">暂无数据</div>
                        <i class="el-icon-error" @click="removeModules(item, index)"></i>
                    </div>
                </div>
            </div>
        </draggable>
    </div>
</template>

<script>
    import draggable from "vuedraggable";
    import { mapGetters, mapActions } from "vuex";
    import {getCardList} from '@/api/managementCenter/specialManage'
    export default {
        name: "linkMaga",
        components: { draggable},
        props: ['childModules'],
        data() {
            return {
                baseUrl: process.env.BASE_URL,
                moduleItems: [],
                span: 1,
                col: 3,
                rulesList: [],
                businessList: [],
                downloadList: [],
            };
        },
        created(){
            let subject = this.moduleList.find((item) => {
                return item.cardType === 'LINKMAGA'
            })
            if(subject){
                this.moduleItems = JSON.parse(JSON.stringify(subject.cardModules));
                this.col = subject.cardCol
            }
        },
        computed: {
            ...mapGetters(['moduleList']),
        },
        mounted(){
            this.getCardData('3');
            this.getCardData('4');
            this.getCardData('5');
        },
        methods: {
            getCardData(type){
                let params = {
                    type: type || ''
                }
                getCardList(params).then(res =>{
                    if(type == '3'){
                        this.rulesList = res.data.data.records
                    }
                    if(type == '4'){
                        this.businessList = res.data.data.records
                    }
                    if(type == '5'){
                        this.downloadList = res.data.data.records
                    }
                })
            },
            changeLayout(){
                // if(this.col * this.span < this.moduleItems.length){
                //   this.moduleItems.length = this.col * this.span
                // }
                this.$emit('caseChanged', true)
            },
            handleWidth(col){
                switch (col) {
                    case 1:
                        return '100%'
                    case 2:
                        return '50%'
                    case 3:
                        return '33.3%'
                    case 4:
                        return '25%'
                    case 5:
                        return '20%'
                    case 6:
                        return '16.6%'
                    default:
                        return '50%'
                }
            },
            addModuleItem(e){
                // // 判断是否超出个数限制
                // const limit = this.span * this.col;
                // if(this.moduleItems.length >= limit){
                //   this.$message.warning('超出设置的行数,若要继续添加请修改行列数')
                //   return
                // }
                let targetIndex = e.newIndex;
                let childModulesIndex = e.oldIndex;
                let childModule = this.childModules[childModulesIndex];
                // 判断添加的模块是否存在
                // const exist = this.moduleItems.some((item) => {
                //   return item.code === childModule.code;
                // })
                let exist;
                if(this.moduleItems){
                    exist = this.moduleItems.some((item) => {
                        return item.code === childModule.code;
                    })
                }else {
                    this.moduleItems = []
                    exist = false
                }
                if(exist){
                    this.$message.warning('不能重复添加已添加的模块')
                    return
                }
                this.moduleItems.splice(targetIndex, 0, childModule);
                this.$emit('caseChanged', true)
            },
            sortModuleItem(e){
                let newIndex = e.newIndex;
                let oldIndex = e.oldIndex;

                let moduleItem = this.moduleItems[oldIndex];
                this.moduleItems.splice(oldIndex, 1);
                this.moduleItems.splice(newIndex, 0, moduleItem);
                this.$emit('caseChanged', true)
            },
            removeModules(item, index){
                this.moduleItems.splice(index, 1)
                this.$emit('caseChanged', true)
            },
            isEmpty(){
                return this.moduleItems.length ? false : true
            },
        },
        watch: {
            moduleItems(val){
                this.$emit('selectedChange', {data:val, module: 'linkMaga', col: this.col})
            },
            col(val){
                this.$emit('selectedChange', {data:this.moduleItems, module: 'linkMaga', col: this.col})
            }
        },
        filters: {}
    }
</script>

<style lang="less">
    .module-draggable {
        /*height: 500px;*/
        overflow: scroll;
        background-color: #fff;
        padding: 15px 10px;
        margin-bottom: 15px;
        display: flex;
        flex-wrap: wrap;
        .card-items-ghost-1 {
            display: inline-block;
            width: 100%;
            height: 170px;
            padding-right: 5px;
            padding-left: 5px;
            margin-bottom: 10px;
            /deep/ .card-item {
                background-color: #F2F3F6;
                padding: 15px;
                width: 100%;
                border: 1px dashed #ccc;
                height: 170px;
                margin: 0;
                .selected {
                    display: none;
                }
            }
        }
        .card-items-ghost-2 {
            display: inline-block;
            width: 50%;
            height: 170px;
            padding-left: 5px;
            padding-right: 5px;
            /deep/ .card-item {
                background-color: #F2F3F6;
                padding: 15px;
                width: 100%;
                border: 1px dashed #ccc;
                height: 170px;
                margin: 0;
                .selected {
                    display: none;
                }
            }
        }
        .card-items-ghost-3 {
            display: inline-block;
            width: 33.3%;
            height: 170px;
            padding-left: 5px;
            padding-right: 5px;
            /deep/ .card-item {
                background-color: #F2F3F6;
                padding: 15px;
                width: 100%;
                border: 1px dashed #ccc;
                height: 170px;
                margin: 0;
                .selected {
                    display: none;
                }
            }
        }
        .card-items-ghost-4 {
            display: inline-block;
            width: 25%;
            height: 170px;
            padding-left: 5px;
            padding-right: 5px;
            /deep/ .card-item {
                background-color: #F2F3F6;
                padding: 15px;
                width: 100%;
                border: 1px dashed #ccc;
                height: 170px;
                margin: 0;
                .selected {
                    display: none;
                }
            }
        }
        .card-items-ghost-5 {
            display: inline-block;
            width: 20%;
            height: 170px;
            padding-right: 5px;
            padding-left: 5px;
            /deep/ .card-item {
                background-color: #F2F3F6;
                padding: 15px;
                width: 100%;
                border: 1px dashed #ccc;
                height: 170px;
                margin: 0;
                .selected {
                    display: none;
                }
            }
        }
        .card-items-ghost-6 {
            display: inline-block;
            width: 16.6%;
            height: 170px;
            padding-right: 5px;
            padding-left: 5px;
            /deep/ .card-item {
                background-color: #F2F3F6;
                padding: 15px;
                width: 100%;
                border: 1px dashed #ccc;
                height: 170px;
                margin: 0;
                .selected {
                    display: none;
                }
            }
        }
        .module-items {
            height: 260px;
            padding: 0 5px 10px;
            .module-item {
                height: 100%;
                background-color: #F2F3F6;
                position: relative;
                // text-align: center;
                // line-height: 170px;
                padding: 15px;
                line-height: 14px;
                cursor: move;
                >i {
                    position: absolute;
                    top: 10px;
                    right: 10px;
                    color: #1764A5;
                    font-size: 23px;
                    cursor: pointer;
                }
                &:hover {
                    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
                    .el-icon-error {
                        display: block;
                    }
                }
                .msg-item {
                    cursor: inherit;
                }
            }
        }
    }
    .module-layout {
        padding-bottom: 24px;
        display: flex;
        justify-content: center;
        align-items: center;

    }
    .titleClass{
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px #e9e9e9 solid;
        padding: 5px 0;
    }
</style>